<template>
    <div class="profile__tegs">
        <div class="profile__tegs_content">
            <div v-for="teg in visibleTegs" class="profile__teg" :class="{ clickable: teg.url }"
                @click="teg.url ? openLink(teg.url) : null">
                <img :src="teg.icon" alt="" loading="lazy">
                <span>{{ teg.title }}</span>
            </div>
        </div>

        <div v-if="tegs.length > 2" class="profile__teg_btn" @click="showAllTegs = !showAllTegs">
            <img src="/arrow.svg" :style="{ transform: showAllTegs ? 'rotate(180deg)' : 'rotate(0deg)' }" loading="lazy"
                alt="arrow">
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileTegs",
    props: {
        user: { type: Object }
    },
    data() {
        return { showAllTegs: false }
    },
    computed: {
        tegs() {
            if (!this.user) return [];

            const link = this.user.links?.[0];
            const domain = link ? this.extractDomain(link) : null; // Получаем домен (youtube, vk, twitter)

            return [
                { title: this.user.location, icon: "/location.svg" },
                { title: this.birthday, icon: "/Birthday.svg" },
                { title: this.user.email, icon: "/Birthday.svg" },
                { title: domain, url: link, icon: "/Birthday.svg" },
            ].filter(t => t.title);
        },
        visibleTegs() {
            return this.showAllTegs ? this.tegs : this.tegs.slice(0, 2);
        },
        birthday() {
            return this.user?.birthday
                ? new Date(this.user.birthday).toLocaleDateString("en-EN", {
                    month: "long",
                    day: "2-digit",
                })
                : "";
        },
    },
    methods: {
        extractDomain(url) {
            try {
                const normalized = url.startsWith("http") ? url : "https://" + url;
                const hostname = new URL(normalized).hostname.replace("www.", "");

                return hostname.split(".")[0];
            } catch (e) { return url; }
        },
        openLink(url) {
            if (!url) return;

            const normalized = url.startsWith("http") ? url : "https://" + url;
            window.open(normalized, "_blank");
        },
    }
}
</script>

<style>
.profile__tegs {
    display: flex;
    align-self: flex-end;
    justify-content: flex-end;
    align-items: flex-start;
    max-width: 40%;
}

.profile__tegs_content {
    margin-right: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 8px;
}

.profile__teg {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 10px;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.2);
    font-size: 15px;
    font-weight: 500;
    height: 36px;
    text-transform: capitalize;
}

.profile__teg img {
    width: 16px;
    height: 16px;
}

.profile__teg.clickable {
    cursor: pointer;
    transition: 0.2s;
}

.profile__teg.clickable:hover {
    background-color: rgba(255, 255, 255, 0.35);
}

.profile__teg_btn {
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.2);
    padding: 6px 15px;
    cursor: pointer;
    align-self: flex-start;
}

.profile__teg_btn:hover {
    background: rgba(255, 255, 255, 0.35);
}

.profile__teg_btn img {
    width: 10px;
    height: 10px;
}

@media (max-width: 500px) {
    .profile__tegs {
        flex-direction: column-reverse;
        margin-right: 0;
    }

    .profile__teg span {
        font-size: 12px;
    }

    .profile__teg_btn {
        align-self: flex-end;
        margin-bottom: 5px;
    }

    .profile__tegs_content {
        margin-right: 0;
    }
}
</style>
